import { AfterContentInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CallbackService } from 'src/app/callback/callback.service';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { Aac_PermitionDto } from 'src/app/models/afs/aac_PermitionDto';
import { Aac_PermitionService } from 'src/app/services/entity/aac_permition.service';
import { EntityService } from 'src/app/services/entity/entity.service';
import { RxjObservableService } from 'src/app/services/rxjObservable.service';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { YesOrNoComponent } from 'src/app/dialog/yes-or-no/yes-or-no.component';
import { AppConfig } from 'src/app/core/_config/app.config';

@Component({
    selector: 'app-context',
    templateUrl: './context.component.html',
    styleUrls: ['./context.component.scss'],
})
export class ContextComponent implements AfterContentInit, OnInit {
    myControl = new FormControl();
    EntityPermissionSelected: Aac_PermitionDto = null;
    EntitiesPermission: Aac_PermitionDto[] = [];
    filterEntities: Observable<Aac_PermitionDto[]>;
    public isLoading = new Subject<boolean>();

    constructor(
        public rxjs: RxjObservableService,
        public loaderService: LoaderService,
        public aac_PermitionService: Aac_PermitionService,
        public entityService: EntityService,
        private callBackService: CallbackService,
        public _loaderService: LoaderService,
        private cdRef: ChangeDetectorRef,
        private _sessionBusiness: SessionBusiness,
        private _notification: NotificationsService,
        private route: Router,
        private config: AppConfig,
        private _dialog: MatDialog,
    ) {}

    public session_Entities = [];
    public session_contextSelected = { EntityDescription: null, EntityId: null, LegalEntityId: null };

    ngOnInit() {
        this.loadBrowserSession();
    }

    public loadBrowserSession() {
        this.session_Entities = JSON.parse(sessionStorage.getItem('SessionEntities'));
        this.session_contextSelected = JSON.parse(sessionStorage.getItem('ContextSelected'));
    }

    public async initRxjObservable() {
        this.rxjs.getObservable().subscribe(async (result) => {
            if (result.value && result.value === 'GetEntityPermission') {
                this.GetEntityPermission();
            }
        });
    }

    ngAfterContentInit() {
        this.initRxjObservable();
        this.GetEntityPermission();
        this.SetInitialContextSelectedBySession();
    }

    displayContextName(item?: Aac_PermitionDto): string | undefined {
        return item ? item.description : undefined;
    }

    GetEntityPermission() {
        this.Load(true);
        //todas entidades são guardadas na sessão

        if (this.session_Entities?.length > 0) {
            this.EntitiesPermission = this.session_Entities;
            this.createFilter(this.session_Entities);
            this.SetInitialContextSelectedBySession();
        } else {
            //caso não exista procurar
            this.aac_PermitionService.GetEntityPermission()?.subscribe(
                (result) => {
                    if (result.success) {
                        this.EntitiesPermission = result.data;
                        //adicionar na sessão
                        this.createFilter(result.data);
                        this.CreateSessionEntities(result.data);
                        this.loadBrowserSession();
                        this.SetInitialContextSelectedBySession();
                    }
                    this.Load(false);
                },
                (error) => {
                    if (error.status == 401) {
                        this._notification.error('Atenção', 'SEM ACESSO PARA ACESSAR O SISTEMA');

                        this.yesOrNoDialog('Sem acesso', 'Deseja voltar para o sistema principal?').subscribe(
                            (result) => {
                                if (result) {
                                    sessionStorage.clear();
                                    window.location.href = this.config.urlOldAfs;
                                }
                            },
                        );
                        this.route.navigate(['error']);
                    }
                },
            );
        }
        this.Load(false);
    }

    private yesOrNoDialog(title: string, text: string): Observable<any> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = 260;
        dialogConfig.data = {
            title: title,
            text: text,
        };
        const dialogRef = this._dialog.open(YesOrNoComponent, dialogConfig);
        return dialogRef.afterClosed();
    }

    onChangeEntity(item: Aac_PermitionDto) {
        if (this.EntityPermissionSelected?.entityId != item.entityId) {
            this.Load(true);
            this.entityService.GetEntity(item.entityId).subscribe((resultDb: any) => {
                this._sessionBusiness.EntityIdContext = item.entityId;
                this._sessionBusiness.EntityDescriptionContext = resultDb.description;
                this._sessionBusiness.LegalEntityIdContext = resultDb.legalEntityId;
                this.ChangeSessionNewEntity(item, resultDb?.legalEntityId);
                this._notification.success('Entidade Selecionada!');
                this.reconectApi();
                this.Load(false);
            });
        } else {
            this._notification.warn('Selecione uma entidade diferente');
        }
        this.SelectComboboxContext(item.entityId);
    }

    private SelectComboboxContext(entityId: string) {
        var find = this.session_Entities?.find((opt) => opt.entityId.toLowerCase() == entityId.toLowerCase());

        if (!find) {
            this.myControl.setValue({ description: this.session_contextSelected.EntityDescription });
            console.error(`Verifique seu acesso à Entidade: ${this.session_contextSelected.EntityDescription}`);
        } else {
            this.myControl.setValue({ description: find.description });
            this.EntityPermissionSelected = find;
        }
    }

    private SetInitialContextSelectedBySession() {
        if (this.session_Entities && this.session_contextSelected) {
            this.SelectComboboxContext(this.session_contextSelected.EntityId);
        }
        this.cdRef.detectChanges();
    }

    private CreateSessionEntities(allData: Aac_PermitionDto[]) {
        if (allData && allData.length > 0) {
            let key = 'SessionEntities';
            let entities = [];
            sessionStorage.removeItem(key);
            allData.forEach((element) => {
                let entityId = element.entityId;
                let description = element.description;
                entities.push({ entityId, description });
            });
            sessionStorage.setItem(key, JSON.stringify(entities));
        }
    }

    private createFilter(allData: Aac_PermitionDto[]) {
        this.EntitiesPermission = allData;
        this.filterEntities = this.myControl.valueChanges.pipe(
            startWith(''),
            map((value) => (typeof value === 'string' ? value : value.description)),
            map((name) => (name ? this._filter(name) : this.EntitiesPermission.slice())),
        );
    }

    private reconectApi() {
        this.callBackService.accountsLogin().then(() => {
            this.cdRef.detectChanges();
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        });
    }

    private _filter(value: string): Aac_PermitionDto[] {
        const filterValue = value?.toLowerCase();
        return this.EntitiesPermission.filter((option) => option.description.toLowerCase().includes(filterValue));
    }

    private ChangeSessionNewEntity(newEntity: Aac_PermitionDto, legalEntityId: string) {
        this.session_contextSelected.EntityId = newEntity.entityId;
        this.session_contextSelected.EntityDescription = newEntity.description;
        this.session_contextSelected.LegalEntityId = legalEntityId;

        sessionStorage.setItem('ContextSelected', JSON.stringify(this.session_contextSelected));
    }

    private Load(value: boolean) {
        if (value) {
            this._loaderService.show();
        } else {
            this._loaderService.hide();
        }
        this.isLoading = this._loaderService.isLoading;
    }
}
